import { render, staticRenderFns } from "./RepairPlanUpdateDetailSummarySubPage.vue?vue&type=template&id=1373bae5&"
import script from "./RepairPlanUpdateDetailSummarySubPage.vue?vue&type=script&lang=ts&"
export * from "./RepairPlanUpdateDetailSummarySubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports